/**
 * @name DependentesFunctionsService
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Service para functions relacionadas à gestão de dependentes
 * @package services/supabase/functions
 */

import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { supabase } from '../../../../supabaseConfig';

/**
 * Service para functions de gestão de dependentes
 */
export class DependentesFunctionsService {

     /**
      * Distribui saldo do responsável para um dependente específico
      */
     static async distribuirSaldoDependente(
          idResponsavel: number,
          idAluno: number,
          idOrganizacao: number,
          valor: number,
          observacoes?: string
     ): Promise<PostgrestSingleResponse<any>> {
          return supabase.rpc('fn_distribuir_saldo_dependente', {
               p_id_responsavel: idResponsavel,
               p_id_aluno: idAluno,
               p_id_organizacao: idOrganizacao,
               p_valor: valor,
               p_observacoes: observacoes
          });
     }

     /**
      * Transfere saldo entre dependentes do mesmo responsável
      */
     static async transferirEntreDependentes(
          idResponsavel: number,
          idAlunoOrigem: number,
          idAlunoDestino: number,
          idOrganizacao: number,
          valor: number,
          observacoes?: string
     ): Promise<PostgrestSingleResponse<any>> {
          return supabase.rpc('fn_transferir_entre_dependentes', {
               p_id_responsavel: idResponsavel,
               p_id_aluno_origem: idAlunoOrigem,
               p_id_aluno_destino: idAlunoDestino,
               p_id_organizacao: idOrganizacao,
               p_valor: valor,
               p_observacoes: observacoes
          });
     }
}

export const dependentesFunctionsService = DependentesFunctionsService;
